  <table
    mat-table
    matSort
    [dataSource]="dataSource"
    role="grid"
    aria-label="Applications Table"
    (matSortChange)="sortApplications($event)"
  >
    <caption class="sr-only">Applications Data Table</caption>
    
    <!-- Checkbox Column -->
    <ng-container *ngIf="multiselectcheckbox" matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef scope="col">
        <mat-checkbox
          (change)="$event ? toggleAllRows() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
          [aria-label]="checkboxLabel()"
        >
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
          [aria-label]="checkboxLabel(row)"
        >
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- Dynamic Columns -->
    <ng-container
      *ngFor="let column of columns"
      matColumnDef="{{ column.key }}"
    >
      <th mat-header-cell *matHeaderCellDef scope="col">
        {{ column.label }}
        <i
          *ngIf="showSortIcon"
          class="fa-solid fa-sort sort-icon"
          role="button"
          tabindex="0"
          (click)="sortColumn(column.key)"
          (keydown.enter)="sortColumn(column.key)"
          (keydown.space)="sortColumn(column.key)"
          title="Sort"
          aria-hidden="true"
        ></i>
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container
          *ngIf="
            column.key != 'completionStatus' &&
            column.key != 'actions' &&
            column.key != 'updatedDate' &&
            column.key != 'role' &&
            column.key != 'timeConsumedInPercentage' &&
            column.key != 'caseCompletionStatus' &&
            column.key != 'renewal'
          "
        >
          {{ element[column.key] }}
        </ng-container>
        <ng-container *ngIf="column.key == 'role'">
          <span class="user-role">
            {{ element.role === "ADMIN" ? "Admin" : "Case Manager" }}
          </span>
        </ng-container>
        <ng-container *ngIf="column.key == 'updatedDate'">
          {{ element.updatedDate | date : "MM/dd/yyyy hh:mm a" }}
        </ng-container>
        <ng-container *ngIf="column.key == 'completionStatus'">
          <span
            *ngIf="element.completionStatus === 0"
            class="status status_in_progress"
            role="status"
            aria-label="In Progress"
            >In Progress</span
          >
          <span
            *ngIf="element.completionStatus === 1"
            class="status status_submitted"
            role="status"
            aria-label="Submitted"
            >Submitted</span
          >
          <span
            *ngIf="
              element.completionStatus === 2 || element.completionStatus === 3
            "
            class="status status_terminated"
            role="status"
            aria-label="Terminated"
          >
            Terminated
          </span>
        </ng-container>
        <ng-container *ngIf="column.key == 'actions'">
          <div class="icon-row">
            <button
              class="action_icons btn"
              type="button"
              title="View User"
              aria-label="View User"
              (click)="emitUserData('view', element)"
              (keydown.enter)="emitUserData('view', element)"
              (keydown.space)="emitUserData('view', element)"
              >
              
                <svg width="24" height="24" aria-hidden="true" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.625 5.0625C9.30469 5.0625 7.44141 6.11719 6 7.45312C4.62891 8.71875 3.71484 10.1953 3.22266 11.25C3.71484 12.3047 4.62891 13.8164 6 15.082C7.44141 16.418 9.30469 17.4375 11.625 17.4375C13.9102 17.4375 15.7734 16.418 17.2148 15.082C18.5859 13.8164 19.5352 12.3047 19.9922 11.25C19.5352 10.1953 18.5859 8.71875 17.25 7.45312C15.7734 6.11719 13.9102 5.0625 11.625 5.0625ZM4.83984 6.22266C6.49219 4.67578 8.77734 3.375 11.625 3.375C14.4375 3.375 16.7227 4.67578 18.375 6.22266C20.0273 7.76953 21.1172 9.5625 21.6445 10.8281C21.75 11.1094 21.75 11.4258 21.6445 11.707C21.1172 12.9375 20.0273 14.7656 18.375 16.3125C16.7227 17.8594 14.4375 19.125 11.625 19.125C8.77734 19.125 6.49219 17.8594 4.83984 16.3125C3.1875 14.7656 2.09766 12.9375 1.57031 11.707C1.46484 11.4258 1.46484 11.1094 1.57031 10.8281C2.09766 9.5625 3.1875 7.73438 4.83984 6.22266ZM11.625 14.0625C13.1719 14.0625 14.4375 12.832 14.4375 11.25C14.4375 9.70312 13.1719 8.4375 11.625 8.4375C11.5898 8.4375 11.5547 8.4375 11.5547 8.4375C11.5898 8.64844 11.625 8.82422 11.625 9C11.625 10.2656 10.6055 11.25 9.375 11.25C9.16406 11.25 8.98828 11.25 8.8125 11.1797C8.8125 11.2148 8.8125 11.25 8.8125 11.25C8.8125 12.832 10.043 14.0625 11.625 14.0625ZM11.625 6.75C13.207 6.75 14.6836 7.62891 15.4922 9C16.3008 10.4062 16.3008 12.1289 15.4922 13.5C14.6836 14.9062 13.207 15.75 11.625 15.75C10.0078 15.75 8.53125 14.9062 7.72266 13.5C6.91406 12.1289 6.91406 10.4062 7.72266 9C8.53125 7.62891 10.0078 6.75 11.625 6.75Z" fill="#333333"/>
                </svg>              
            </button>
            <button
              class="action_icons btn"
              type="button"
              title="Edit User"
              aria-label="Edit User"
              (click)="emitUserData('edit', element)"
              (keydown.enter)="emitUserData('edit', element)"
              (keydown.space)="emitUserData('edit', element)"
            >
              <svg width="24" height="24"  aria-hidden="true" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.3359 2.88281H12.3125C12.1016 2.67188 11.75 2.67188 11.5391 2.88281L10.8359 3.5625L11.9375 4.66406L12.6172 3.96094C12.8281 3.75 12.8281 3.39844 12.6172 3.16406L12.3359 2.88281ZM6.89844 7.52344C6.82812 7.57031 6.78125 7.66406 6.75781 7.75781L6.35938 9.11719L7.74219 8.74219C7.83594 8.71875 7.90625 8.67188 7.97656 8.60156L11.1406 5.4375L10.0625 4.35938L6.89844 7.52344ZM10.7422 2.08594C11.3984 1.42969 12.4531 1.42969 13.1094 2.08594L13.4141 2.39062C14.0703 3.04688 14.0703 4.10156 13.4141 4.75781L8.77344 9.39844C8.58594 9.58594 8.32812 9.72656 8.04688 9.82031L5.70312 10.4766C5.51562 10.5469 5.30469 10.5 5.16406 10.3359C5 10.1953 4.95312 9.98438 5 9.79688L5.67969 7.45312C5.75 7.17188 5.91406 6.91406 6.10156 6.72656L10.7422 2.08594ZM4.0625 3H6.6875C6.99219 3 7.25 3.25781 7.25 3.5625C7.25 3.89062 6.99219 4.125 6.6875 4.125H4.0625C3.52344 4.125 3.125 4.54688 3.125 5.0625V11.4375C3.125 11.9766 3.52344 12.375 4.0625 12.375H10.4375C10.9531 12.375 11.375 11.9766 11.375 11.4375V8.8125C11.375 8.50781 11.6094 8.25 11.9375 8.25C12.2422 8.25 12.5 8.50781 12.5 8.8125V11.4375C12.5 12.5859 11.5625 13.5 10.4375 13.5H4.0625C2.91406 13.5 2 12.5859 2 11.4375V5.0625C2 3.9375 2.91406 3 4.0625 3Z" fill="black"/>
              </svg>

          </button>
            <button
              class="action_icons btn"
              type="button"
              title="Delete User"
              aria-label="Delete User"
              (click)="emitUserData('delete', element)"
              (keydown.enter)="emitUserData('delete', element)"
              (keydown.space)="emitUserData('delete', element)"
            >
                <svg width="24" height="24" aria-hidden="true" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.14844 2.625C7.07812 2.625 7.03125 2.67188 6.98438 2.71875L6.53906 3.375H9.9375L9.49219 2.71875C9.46875 2.67188 9.39844 2.625 9.32812 2.625H7.14844ZM11.2969 3.375H11.6016H12.75H12.9375C13.2422 3.375 13.5 3.63281 13.5 3.9375C13.5 4.26562 13.2422 4.5 12.9375 4.5H12.6562L12.0938 12.1172C12.0234 12.9141 11.3906 13.5 10.5938 13.5H5.88281C5.08594 13.5 4.45312 12.9141 4.38281 12.1172L3.82031 4.5H3.5625C3.23438 4.5 3 4.26562 3 3.9375C3 3.63281 3.23438 3.375 3.5625 3.375H3.75H4.875H5.17969L6.04688 2.08594C6.28125 1.73438 6.70312 1.5 7.14844 1.5H9.32812C9.77344 1.5 10.1953 1.73438 10.4297 2.08594L11.2969 3.375ZM11.5312 4.5H4.94531L5.50781 12.0469C5.53125 12.2344 5.69531 12.375 5.88281 12.375H10.5938C10.7812 12.375 10.9453 12.2344 10.9688 12.0469L11.5312 4.5Z" fill="black"/>
                </svg>
            </button>
          </div>
        </ng-container>
        <!-- add another another with unique key and the buttons specially for case list actions -->
        <ng-container *ngIf="column.key == 'actionsApplications'">
          <!--completionStatus : In Progress = 0;
              completionStatus : Submitted = 1;
              completionStatus : Terminated = 2;
              completionStatus : MANUALLY_TERMINATED = 3; -->
          <div class="icon-row">
            <button
              class="action_icons btn"
              type="button"
              *ngIf="
                (isEligibilityAutoDetermined) &&
                (element?.completionStatus == 1 ||
                element?.completionStatus == 2 ||
                element?.completionStatus == 3)
              "
              title="View Application"
              aria-label="View Application"
              (click)="
                emitApplicationData(
                  element?.completionStatus,
                  element.applicationId,
                  '',
                  '',
                  ''
                )
              "
              (keydown.enter)="
                emitApplicationData(
                  element?.completionStatus,
                  element.applicationId,
                  '',
                  '',
                  ''
                )
              "
              (keydown.space)="
                emitApplicationData(
                  element?.completionStatus,
                  element.applicationId,
                  '',
                  '',
                  ''
                )
              "
            >
              <svg width="24" height="24" aria-hidden="true" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.75 3.375C6.20312 3.375 4.96094 4.07812 4 4.96875C3.08594 5.8125 2.47656 6.79688 2.14844 7.5C2.47656 8.20312 3.08594 9.21094 4 10.0547C4.96094 10.9453 6.20312 11.625 7.75 11.625C9.27344 11.625 10.5156 10.9453 11.4766 10.0547C12.3906 9.21094 13.0234 8.20312 13.3281 7.5C13.0234 6.79688 12.3906 5.8125 11.5 4.96875C10.5156 4.07812 9.27344 3.375 7.75 3.375ZM3.22656 4.14844C4.32812 3.11719 5.85156 2.25 7.75 2.25C9.625 2.25 11.1484 3.11719 12.25 4.14844C13.3516 5.17969 14.0781 6.375 14.4297 7.21875C14.5 7.40625 14.5 7.61719 14.4297 7.80469C14.0781 8.625 13.3516 9.84375 12.25 10.875C11.1484 11.9062 9.625 12.75 7.75 12.75C5.85156 12.75 4.32812 11.9062 3.22656 10.875C2.125 9.84375 1.39844 8.625 1.04688 7.80469C0.976562 7.61719 0.976562 7.40625 1.04688 7.21875C1.39844 6.375 2.125 5.15625 3.22656 4.14844ZM7.75 9.375C8.78125 9.375 9.625 8.55469 9.625 7.5C9.625 6.46875 8.78125 5.625 7.75 5.625C7.72656 5.625 7.70312 5.625 7.70312 5.625C7.72656 5.76562 7.75 5.88281 7.75 6C7.75 6.84375 7.07031 7.5 6.25 7.5C6.10938 7.5 5.99219 7.5 5.875 7.45312C5.875 7.47656 5.875 7.5 5.875 7.5C5.875 8.55469 6.69531 9.375 7.75 9.375ZM7.75 4.5C8.80469 4.5 9.78906 5.08594 10.3281 6C10.8672 6.9375 10.8672 8.08594 10.3281 9C9.78906 9.9375 8.80469 10.5 7.75 10.5C6.67188 10.5 5.6875 9.9375 5.14844 9C4.60938 8.08594 4.60938 6.9375 5.14844 6C5.6875 5.08594 6.67188 4.5 7.75 4.5Z" fill="black"/>
              </svg>

            </button>
            <button
              class="action_icons btn"
              type="button"
              *ngIf="
                (!isEligibilityAutoDetermined) &&
                (element?.completionStatus == 1 ||
                element?.completionStatus == 2 ||
                element?.completionStatus == 3)
              "
              [title]="element?.completionStatus == 1 ? 'View Case' : 'View Application'"
              [attr.aria-label]="element?.completionStatus == 1 ? 'View Case' : 'View Application'"
              (click)="
                emitApplicationData(
                  element?.completionStatus,
                  element.applicationId,
                  '',
                  '',
                  element?.workflowStatusId
                )
              "
              (keydown.enter)="
                emitApplicationData(
                  element?.completionStatus,
                  element.applicationId,
                  '',
                  '',
                  element?.workflowStatusId
                )
              "
              (keydown.space)="
                emitApplicationData(
                  element?.completionStatus,
                  element.applicationId,
                  '',
                  '',
                  element?.workflowStatusId
                )
              "
            >
              <svg width="24" height="24" aria-hidden="true" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.75 3.375C6.20312 3.375 4.96094 4.07812 4 4.96875C3.08594 5.8125 2.47656 6.79688 2.14844 7.5C2.47656 8.20312 3.08594 9.21094 4 10.0547C4.96094 10.9453 6.20312 11.625 7.75 11.625C9.27344 11.625 10.5156 10.9453 11.4766 10.0547C12.3906 9.21094 13.0234 8.20312 13.3281 7.5C13.0234 6.79688 12.3906 5.8125 11.5 4.96875C10.5156 4.07812 9.27344 3.375 7.75 3.375ZM3.22656 4.14844C4.32812 3.11719 5.85156 2.25 7.75 2.25C9.625 2.25 11.1484 3.11719 12.25 4.14844C13.3516 5.17969 14.0781 6.375 14.4297 7.21875C14.5 7.40625 14.5 7.61719 14.4297 7.80469C14.0781 8.625 13.3516 9.84375 12.25 10.875C11.1484 11.9062 9.625 12.75 7.75 12.75C5.85156 12.75 4.32812 11.9062 3.22656 10.875C2.125 9.84375 1.39844 8.625 1.04688 7.80469C0.976562 7.61719 0.976562 7.40625 1.04688 7.21875C1.39844 6.375 2.125 5.15625 3.22656 4.14844ZM7.75 9.375C8.78125 9.375 9.625 8.55469 9.625 7.5C9.625 6.46875 8.78125 5.625 7.75 5.625C7.72656 5.625 7.70312 5.625 7.70312 5.625C7.72656 5.76562 7.75 5.88281 7.75 6C7.75 6.84375 7.07031 7.5 6.25 7.5C6.10938 7.5 5.99219 7.5 5.875 7.45312C5.875 7.47656 5.875 7.5 5.875 7.5C5.875 8.55469 6.69531 9.375 7.75 9.375ZM7.75 4.5C8.80469 4.5 9.78906 5.08594 10.3281 6C10.8672 6.9375 10.8672 8.08594 10.3281 9C9.78906 9.9375 8.80469 10.5 7.75 10.5C6.67188 10.5 5.6875 9.9375 5.14844 9C4.60938 8.08594 4.60938 6.9375 5.14844 6C5.6875 5.08594 6.67188 4.5 7.75 4.5Z" fill="black"/>
              </svg>
            </button>
            <button
              class="action_icons btn"
              type="button"
              *ngIf="element?.completionStatus == 0"
              title="Edit Application"
              aria-label="Edit Application"
              (click)="
                emitApplicationData(
                  element?.completionStatus,
                  element.applicationId,
                  '',
                  '',
                  ''
                )
              "
              (keydown.enter)="
                emitApplicationData(
                  element?.completionStatus,
                  element.applicationId,
                  '',
                  '',
                  ''
                )
              "
              (keydown.space)="
                emitApplicationData(
                  element?.completionStatus,
                  element.applicationId,
                  '',
                  '',
                  ''
                )
              "
            >
              <svg width="24" height="24" viewBox="0 0 16 16" aria-hidden="true" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.3359 2.88281H12.3125C12.1016 2.67188 11.75 2.67188 11.5391 2.88281L10.8359 3.5625L11.9375 4.66406L12.6172 3.96094C12.8281 3.75 12.8281 3.39844 12.6172 3.16406L12.3359 2.88281ZM6.89844 7.52344C6.82812 7.57031 6.78125 7.66406 6.75781 7.75781L6.35938 9.11719L7.74219 8.74219C7.83594 8.71875 7.90625 8.67188 7.97656 8.60156L11.1406 5.4375L10.0625 4.35938L6.89844 7.52344ZM10.7422 2.08594C11.3984 1.42969 12.4531 1.42969 13.1094 2.08594L13.4141 2.39062C14.0703 3.04688 14.0703 4.10156 13.4141 4.75781L8.77344 9.39844C8.58594 9.58594 8.32812 9.72656 8.04688 9.82031L5.70312 10.4766C5.51562 10.5469 5.30469 10.5 5.16406 10.3359C5 10.1953 4.95312 9.98438 5 9.79688L5.67969 7.45312C5.75 7.17188 5.91406 6.91406 6.10156 6.72656L10.7422 2.08594ZM4.0625 3H6.6875C6.99219 3 7.25 3.25781 7.25 3.5625C7.25 3.89062 6.99219 4.125 6.6875 4.125H4.0625C3.52344 4.125 3.125 4.54688 3.125 5.0625V11.4375C3.125 11.9766 3.52344 12.375 4.0625 12.375H10.4375C10.9531 12.375 11.375 11.9766 11.375 11.4375V8.8125C11.375 8.50781 11.6094 8.25 11.9375 8.25C12.2422 8.25 12.5 8.50781 12.5 8.8125V11.4375C12.5 12.5859 11.5625 13.5 10.4375 13.5H4.0625C2.91406 13.5 2 12.5859 2 11.4375V5.0625C2 3.9375 2.91406 3 4.0625 3Z" fill="black"/>
              </svg>

            </button>
            <button
              class="action_icons btn"
              type="button"
              *ngIf="
                (((element?.completionStatus == 1 ||
                  element?.completionStatus == 2 ||
                  element?.completionStatus == 3)) &&
                  (!element?.historical) &&
                  (isEligibilityAutoDetermined))
                  ||
                (
                  ((element?.completionStatus == 1 ||
                  element?.completionStatus == 2 ||
                  element?.completionStatus == 3)) &&
                  (!element?.historical) &&
                  (
                    (!isEligibilityAutoDetermined)
                    && (element?.workflowStatus?.toLowerCase() === 'determination approved' || 
                        element?.workflowStatus?.toLowerCase() === 'determination denied' || 
                        element?.workflowStatus?.toLowerCase() === 'determination letter sent' ||
                        element?.workflowStatus?.toLowerCase() === 'approval letter sent' ||
                        element?.workflowStatus?.toLowerCase() === 'denial letter sent')
                  )
                )
              "
              title="Download Determination Letter"
              aria-label="Download Determination Letter"
              (click)="
                emitApplicationData(
                  element?.completionStatus,
                  element?.applicationId,
                  'download',
                  '',
                  ''
                )
              "
              (keydown.enter)="
                emitApplicationData(
                  element?.completionStatus,
                  element?.applicationId,
                  'download',
                  '',
                  ''
                )
              "
              (keydown.space)="
                emitApplicationData(
                  element?.completionStatus,
                  element?.applicationId,
                  'download',
                  '',
                  ''
                )
              "
            >
                <svg width="24" height="24" aria-hidden="true" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.4375 12.75H3.5625C3.23438 12.75 3 12.5156 3 12.1875C3 11.8828 3.23438 11.625 3.5625 11.625H11.4375C11.7422 11.625 12 11.8828 12 12.1875C12 12.5156 11.7422 12.75 11.4375 12.75ZM7.07812 9.58594L4.07812 6.39844C3.86719 6.16406 3.89062 5.8125 4.10156 5.60156C4.33594 5.39062 4.6875 5.39062 4.89844 5.625L6.9375 7.78125V5.8125V2.8125C6.9375 2.50781 7.17188 2.25 7.5 2.25C7.80469 2.25 8.0625 2.50781 8.0625 2.8125V5.8125V7.78125L10.0781 5.625C10.2891 5.39062 10.6406 5.39062 10.875 5.60156C11.1094 5.8125 11.1094 6.16406 10.8984 6.39844L7.89844 9.58594C7.78125 9.70312 7.64062 9.75 7.5 9.75C7.33594 9.75 7.19531 9.70312 7.07812 9.58594Z" fill="black"/>
                </svg>
            </button>
            <button
              class="action_icons btn"
              type="button"
              *ngIf="element?.completionStatus == 1"
              title="Terminate Application"
              aria-label="Terminate Application"
              (click)="
                emitApplicationData(
                  element?.completionStatus,
                  element.applicationId,
                  '',
                  'terminate',
                  ''
                )
              "
              (keydown.enter)="
                emitApplicationData(
                  element?.completionStatus,
                  element.applicationId,
                  '',
                  'terminate',
                  ''
                )
              "
              (keydown.space)="
                emitApplicationData(
                  element?.completionStatus,
                  element.applicationId,
                  '',
                  'terminate',
                  ''
                )
              "
            >
              <svg width="24" height="24" aria-hidden="true" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M11.3477 4.95508L8.53516 7.76758L11.3242 10.5566C11.5586 10.7676 11.5586 11.1191 11.3242 11.3301C11.1133 11.5645 10.7617 11.5645 10.5508 11.3301L7.73828 8.54102L4.94922 11.3301C4.73828 11.5645 4.38672 11.5645 4.17578 11.3301C3.94141 11.1191 3.94141 10.7676 4.17578 10.5332L6.96484 7.74414L4.17578 4.95508C3.94141 4.74414 3.94141 4.39258 4.17578 4.1582C4.38672 3.94727 4.73828 3.94727 4.97266 4.1582L7.76172 6.9707L10.5508 4.18164C10.7617 3.94727 11.1133 3.94727 11.3477 4.18164C11.5586 4.39258 11.5586 4.74414 11.3477 4.95508Z" fill="black"/>
              </svg>
            </button>
            <button
              class="action_icons btn"
              type="button"
              *ngIf="element?.completionStatus == 3"
              title="View Terminated Reason"
              aria-label="View Terminated Reason"
              (click)="
                emitApplicationData(
                  element?.completionStatus,
                  element.applicationId,
                  '',
                  'viewTerminatedReason',
                  ''
                )
              "
              (keydown.enter)="
                emitApplicationData(
                  element?.completionStatus,
                  element.applicationId,
                  '',
                  'viewTerminatedReason',
                  ''
                )
              "
              (keydown.space)="
                emitApplicationData(
                  element?.completionStatus,
                  element.applicationId,
                  '',
                  'viewTerminatedReason',
                  ''
                )
              "
            >
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="column.key == 'renewal'">
          <div style="display: flex;align-items: center;" *ngIf="element?.renewal">
            <span style="margin-right: 15px;width: 70px;">{{ element.renewal }} days</span>
            <button
              *ngIf="!element?.renewalLetterPrinted"
              style="width: 140px;"
              class="button-default mt-43"
              [ngClass]="
                element?.highlightPrintRenewalLetter
                  ? 'custom-btn-primary'
                  : 'custom-btn-secondary'
              "
              aria-label="Print Notice"
              (click)="printRenewalLetter(element)"
            >
              Print Notice
            </button>
            <button
              *ngIf="element?.renewalLetterPrinted"
              style="width: 140px;"
              class="button-default mt-43 custom-btn-secondary"
              aria-label="Re-Print Notice"
              (click)="printRenewalLetter(element)"
            >
              Re-Print Notice
            </button>
            <button
              class="button-default mt-43"
              [ngClass]="
                element?.renewalLetterPrinted
                  ? 'custom-btn-primary'
                  : 'custom-btn-secondary'
              "
              aria-label="Renew"
              style="margin-left: 15px"
              [disabled]="!element?.renewalLetterPrinted"
              (click)="beginRenewal(element)"
            >
              Renew
            </button>
          </div>
          
        </ng-container>
        <ng-container *ngIf="column.key == 'actionsApplicantList'">
          <div class="icon-row">
            <button
              class="action_icons btn"
              type="button"
              title="View Profile"
              aria-label="View Profile"
              (click)="emitApplicantData('view', element.applicantId)"
              (keydown.enter)="emitApplicantData('view', element.applicantId)"
              (keydown.space)="emitApplicantData('view', element.applicantId)"
            >
                <svg width="24" height="24" aria-hidden="true" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.625 5.0625C9.30469 5.0625 7.44141 6.11719 6 7.45312C4.62891 8.71875 3.71484 10.1953 3.22266 11.25C3.71484 12.3047 4.62891 13.8164 6 15.082C7.44141 16.418 9.30469 17.4375 11.625 17.4375C13.9102 17.4375 15.7734 16.418 17.2148 15.082C18.5859 13.8164 19.5352 12.3047 19.9922 11.25C19.5352 10.1953 18.5859 8.71875 17.25 7.45312C15.7734 6.11719 13.9102 5.0625 11.625 5.0625ZM4.83984 6.22266C6.49219 4.67578 8.77734 3.375 11.625 3.375C14.4375 3.375 16.7227 4.67578 18.375 6.22266C20.0273 7.76953 21.1172 9.5625 21.6445 10.8281C21.75 11.1094 21.75 11.4258 21.6445 11.707C21.1172 12.9375 20.0273 14.7656 18.375 16.3125C16.7227 17.8594 14.4375 19.125 11.625 19.125C8.77734 19.125 6.49219 17.8594 4.83984 16.3125C3.1875 14.7656 2.09766 12.9375 1.57031 11.707C1.46484 11.4258 1.46484 11.1094 1.57031 10.8281C2.09766 9.5625 3.1875 7.73438 4.83984 6.22266ZM11.625 14.0625C13.1719 14.0625 14.4375 12.832 14.4375 11.25C14.4375 9.70312 13.1719 8.4375 11.625 8.4375C11.5898 8.4375 11.5547 8.4375 11.5547 8.4375C11.5898 8.64844 11.625 8.82422 11.625 9C11.625 10.2656 10.6055 11.25 9.375 11.25C9.16406 11.25 8.98828 11.25 8.8125 11.1797C8.8125 11.2148 8.8125 11.25 8.8125 11.25C8.8125 12.832 10.043 14.0625 11.625 14.0625ZM11.625 6.75C13.207 6.75 14.6836 7.62891 15.4922 9C16.3008 10.4062 16.3008 12.1289 15.4922 13.5C14.6836 14.9062 13.207 15.75 11.625 15.75C10.0078 15.75 8.53125 14.9062 7.72266 13.5C6.91406 12.1289 6.91406 10.4062 7.72266 9C8.53125 7.62891 10.0078 6.75 11.625 6.75Z" fill="#333333"/>
                </svg>
            </button>
            <button
              class="action_icons btn"
              type="button"
              title="Edit Profile"
              aria-label="Edit Profile"
              (click)="emitApplicantData('edit', element.applicantId)"
              *ngIf="!isEligibilityAutoDetermined && isAddEditApplicantAllowed"
              (keydown.enter)="emitApplicantData('edit', element.applicantId)"
              (keydown.space)="emitApplicantData('edit', element.applicantId)"
            >
                <svg width="24" height="24" viewBox="0 0 16 16" aria-hidden="true" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.3359 2.88281H12.3125C12.1016 2.67188 11.75 2.67188 11.5391 2.88281L10.8359 3.5625L11.9375 4.66406L12.6172 3.96094C12.8281 3.75 12.8281 3.39844 12.6172 3.16406L12.3359 2.88281ZM6.89844 7.52344C6.82812 7.57031 6.78125 7.66406 6.75781 7.75781L6.35938 9.11719L7.74219 8.74219C7.83594 8.71875 7.90625 8.67188 7.97656 8.60156L11.1406 5.4375L10.0625 4.35938L6.89844 7.52344ZM10.7422 2.08594C11.3984 1.42969 12.4531 1.42969 13.1094 2.08594L13.4141 2.39062C14.0703 3.04688 14.0703 4.10156 13.4141 4.75781L8.77344 9.39844C8.58594 9.58594 8.32812 9.72656 8.04688 9.82031L5.70312 10.4766C5.51562 10.5469 5.30469 10.5 5.16406 10.3359C5 10.1953 4.95312 9.98438 5 9.79688L5.67969 7.45312C5.75 7.17188 5.91406 6.91406 6.10156 6.72656L10.7422 2.08594ZM4.0625 3H6.6875C6.99219 3 7.25 3.25781 7.25 3.5625C7.25 3.89062 6.99219 4.125 6.6875 4.125H4.0625C3.52344 4.125 3.125 4.54688 3.125 5.0625V11.4375C3.125 11.9766 3.52344 12.375 4.0625 12.375H10.4375C10.9531 12.375 11.375 11.9766 11.375 11.4375V8.8125C11.375 8.50781 11.6094 8.25 11.9375 8.25C12.2422 8.25 12.5 8.50781 12.5 8.8125V11.4375C12.5 12.5859 11.5625 13.5 10.4375 13.5H4.0625C2.91406 13.5 2 12.5859 2 11.4375V5.0625C2 3.9375 2.91406 3 4.0625 3Z" fill="black"/>
              </svg>
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="column.key == 'timeConsumedInPercentage'">
          <div class="time-remaining-container"
            role="group"
            aria-label="Time Remaining and Progress">
            <span style="text-align: right; display: block; min-width: 60px">
              {{
                !element.timeRemaining.includes("-") ||
                !element.timeRemaining.includes("h")
                  ? element.timeRemaining + " "
                  : element.timeRemaining
              }}</span
            >
            <div
              class="progress"
              [ngStyle]="
                getCombinedProgressStyles(element.timeConsumedInPercentage)
              "
            >
              <div
                class="progress-bar"
                [ngStyle]="
                  getProgressBarStyles(element.timeConsumedInPercentage)
                "
                role="progressbar"
                [style.width.%]="element.timeConsumedInPercentage"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="column.key == 'actionsCases'">
          <div class="icon-row">
            <button
              class="action_icons btn"
              type="button"
              title="View Case"
              aria-label="View Case"
              (click)="emitCaseData('view', element)"
              (keydown.enter)="emitCaseData('view', element)"
              (keydown.space)="emitCaseData('view', element)"
            >
              <svg
                aria-hidden="true"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.625 5.0625C9.30469 5.0625 7.44141 6.11719 6 7.45312C4.62891 8.71875 3.71484 10.1953 3.22266 11.25C3.71484 12.3047 4.62891 13.8164 6 15.082C7.44141 16.418 9.30469 17.4375 11.625 17.4375C13.9102 17.4375 15.7734 16.418 17.2148 15.082C18.5859 13.8164 19.5352 12.3047 19.9922 11.25C19.5352 10.1953 18.5859 8.71875 17.25 7.45312C15.7734 6.11719 13.9102 5.0625 11.625 5.0625ZM4.83984 6.22266C6.49219 4.67578 8.77734 3.375 11.625 3.375C14.4375 3.375 16.7227 4.67578 18.375 6.22266C20.0273 7.76953 21.1172 9.5625 21.6445 10.8281C21.75 11.1094 21.75 11.4258 21.6445 11.707C21.1172 12.9375 20.0273 14.7656 18.375 16.3125C16.7227 17.8594 14.4375 19.125 11.625 19.125C8.77734 19.125 6.49219 17.8594 4.83984 16.3125C3.1875 14.7656 2.09766 12.9375 1.57031 11.707C1.46484 11.4258 1.46484 11.1094 1.57031 10.8281C2.09766 9.5625 3.1875 7.73438 4.83984 6.22266ZM11.625 14.0625C13.1719 14.0625 14.4375 12.832 14.4375 11.25C14.4375 9.70312 13.1719 8.4375 11.625 8.4375C11.5898 8.4375 11.5547 8.4375 11.5547 8.4375C11.5898 8.64844 11.625 8.82422 11.625 9C11.625 10.2656 10.6055 11.25 9.375 11.25C9.16406 11.25 8.98828 11.25 8.8125 11.1797C8.8125 11.2148 8.8125 11.25 8.8125 11.25C8.8125 12.832 10.043 14.0625 11.625 14.0625ZM11.625 6.75C13.207 6.75 14.6836 7.62891 15.4922 9C16.3008 10.4062 16.3008 12.1289 15.4922 13.5C14.6836 14.9062 13.207 15.75 11.625 15.75C10.0078 15.75 8.53125 14.9062 7.72266 13.5C6.91406 12.1289 6.91406 10.4062 7.72266 9C8.53125 7.62891 10.0078 6.75 11.625 6.75Z"
                  fill="#333333"
                />
              </svg>
            </button>
            <button
              class="action_icons btn"
              type="button"
              title="View Case History"
              aria-label="View Case History"
              (click)="emitCaseData('history', element)"
              (keydown.enter)="emitCaseData('history', element)"
              (keydown.space)="emitCaseData('history', element)"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
              aria-controls="offcanvasRight"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
            >
              <svg
                aria-hidden="true"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.6875 7.51172C6.30469 5.26172 8.97656 3.75 12 3.75C16.957 3.75 21 7.79297 21 12.75C21 17.7422 16.957 21.75 12 21.75C10.1367 21.75 8.44922 21.2227 7.00781 20.2734C6.62109 20.0273 6.51562 19.5 6.79688 19.1133C7.04297 18.7266 7.57031 18.6211 7.95703 18.8672C9.11719 19.6406 10.4883 20.0625 12 20.0625C16.0078 20.0625 19.3125 16.793 19.3125 12.75C19.3125 8.74219 16.0078 5.4375 12 5.4375C9.39844 5.4375 7.11328 6.80859 5.8125 8.8125H7.78125C8.23828 8.8125 8.625 9.19922 8.625 9.65625C8.625 10.1484 8.23828 10.5 7.78125 10.5H3.84375C3.35156 10.5 3 10.1484 3 9.65625V5.71875C3 5.26172 3.35156 4.875 3.84375 4.875C4.30078 4.875 4.6875 5.26172 4.6875 5.71875V7.51172ZM12 8.25H11.9648C12.457 8.25 12.8086 8.63672 12.8086 9.09375V12.4336L15.0938 14.7188C15.4453 15.0352 15.4453 15.5625 15.0938 15.8789C14.7773 16.2305 14.25 16.2305 13.9336 15.8789L11.4023 13.3477C11.2266 13.207 11.1562 12.9961 11.1562 12.75V9.09375C11.1562 8.63672 11.5078 8.25 12 8.25Z"
                  fill="#333333"
                />
              </svg>
            </button>
            <button
              class="action_icons btn"
              type="button"
              title="Download Determination Letter"
              aria-label="Download Determination Letter"
              *ngIf="element?.downloadDeterminationLetter"
              (click)="emitCaseData('download', element)"
              (keydown.enter)="emitCaseData('download', element)"
              (keydown.space)="emitCaseData('download', element)"
            >
                <svg width="24" height="24" aria-hidden="true" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.4375 12.75H3.5625C3.23438 12.75 3 12.5156 3 12.1875C3 11.8828 3.23438 11.625 3.5625 11.625H11.4375C11.7422 11.625 12 11.8828 12 12.1875C12 12.5156 11.7422 12.75 11.4375 12.75ZM7.07812 9.58594L4.07812 6.39844C3.86719 6.16406 3.89062 5.8125 4.10156 5.60156C4.33594 5.39062 4.6875 5.39062 4.89844 5.625L6.9375 7.78125V5.8125V2.8125C6.9375 2.50781 7.17188 2.25 7.5 2.25C7.80469 2.25 8.0625 2.50781 8.0625 2.8125V5.8125V7.78125L10.0781 5.625C10.2891 5.39062 10.6406 5.39062 10.875 5.60156C11.1094 5.8125 11.1094 6.16406 10.8984 6.39844L7.89844 9.58594C7.78125 9.70312 7.64062 9.75 7.5 9.75C7.33594 9.75 7.19531 9.70312 7.07812 9.58594Z" fill="black"/>
                </svg>
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="column.key == 'caseCompletionStatus' || column.key == 'caseCompletionGroupStatus' || column.key == 'caseStatusGroup'">
          <span
            class="rounded-badge"
            [ngClass]="{
              'badge_light_purple': element?.caseCompletionGroupStatus?.toLowerCase() == 'review' || element?.caseStatusGroup?.toLowerCase() == 'review',
              'badge_light_blue': element?.caseCompletionGroupStatus?.toLowerCase() == 'determination' || element?.caseStatusGroup?.toLowerCase() == 'determination',
              'badge_light_orange': element?.caseCompletionGroupStatus?.toLowerCase() == 'assessment' || element?.caseStatusGroup?.toLowerCase() == 'assessment',
              'badge_light_red': element.caseCompletionStatus?.toLowerCase() == 'determination denied' || element.caseCompletionStatus?.toLowerCase() == 'denial letter sent',
              'badge_light_green': element.caseCompletionStatus?.toLowerCase() == 'determination letter sent' || element.caseCompletionStatus?.toLowerCase() == 'determination approved'
              || element.caseCompletionStatus?.toLowerCase() == 'approval letter sent',
              badge_light_gray:
                ((!element.caseCompletionStatus || element.caseCompletionStatus?.toLowerCase() == 'draft') &&
                (!element.workflowStatus ||
                element.workflowStatus?.toLowerCase() == 'draft'))
                ||
                (element.caseCompletionStatus?.toLowerCase() == 'terminated')
            }"
              role="img"
          >
            <span
              *ngIf="
                (element.caseCompletionStatus?.toLowerCase() ==
                'determination denied'
                || element.workflowStatus?.toLowerCase() ==
                'determination denied'
                )
                && (element.caseCompletionStatus?.toLowerCase() != 'terminated')
              "
              aria-hidden="true"
            >
              <!-- red disabled icon -->
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.0234 11.3438L4.15625 4.47656C3.5 5.32031 3.125 6.375 3.125 7.5C3.125 10.1953 5.30469 12.375 8 12.375C9.125 12.375 10.1797 12 11.0234 11.3438ZM11.8203 10.5469C12.4766 9.70312 12.875 8.64844 12.875 7.5C12.875 4.82812 10.6719 2.625 8 2.625C6.85156 2.625 5.79688 3.02344 4.95312 3.67969L11.8203 10.5469ZM2 7.5C2 5.36719 3.125 3.39844 5 2.32031C6.85156 1.24219 9.125 1.24219 11 2.32031C12.8516 3.39844 14 5.36719 14 7.5C14 9.65625 12.8516 11.625 11 12.7031C9.125 13.7812 6.85156 13.7812 5 12.7031C3.125 11.625 2 9.65625 2 7.5Z" fill="#FF0021"/>
              </svg>
            </span>
            <span
              *ngIf="
                (element.caseCompletionStatus?.toLowerCase() ==
                'denial letter sent'
                || element.workflowStatus?.toLowerCase() ==
                'denial letter sent'
                )
                && (element.caseCompletionStatus?.toLowerCase() != 'terminated')
              "
              aria-hidden="true"
            >
              <!-- red upload icon -->
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="17 8 12 3 7 8"/>
                <line x1="12" y1="3" x2="12" y2="15"/>
              </svg>
            </span>
            <span
              *ngIf="
                (element.caseCompletionStatus?.toLowerCase() ==
                'determination letter sent'
                || element.workflowStatus?.toLowerCase() ==
                'determination letter sent' || element.workflowStatus?.toLowerCase() ==
                'approval letter sent')
                && (element.caseCompletionStatus?.toLowerCase() != 'terminated')
              "
            >
              <!-- green upload icon -->
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.5625 8.25C8.5625 8.57812 8.30469 8.8125 8 8.8125C7.67188 8.8125 7.4375 8.57812 7.4375 8.25V3.42188L5.96094 4.89844C5.72656 5.13281 5.375 5.13281 5.16406 4.89844C4.92969 4.6875 4.92969 4.33594 5.16406 4.10156L7.60156 1.66406C7.8125 1.45312 8.16406 1.45312 8.375 1.66406L10.8359 4.10156C11.0469 4.33594 11.0469 4.6875 10.8359 4.89844C10.6016 5.13281 10.25 5.13281 10.0391 4.89844L8.5625 3.42188V8.25ZM5.49219 11.0156L5.04688 10.125H3.125V12.375H12.875V10.125H10.9297L10.5078 11.0156C10.2969 11.3906 9.92188 11.625 9.5 11.625H6.5C6.05469 11.625 5.67969 11.3906 5.49219 11.0156ZM6.05469 9.63281L6.5 10.5H9.5L9.92188 9.63281C10.1094 9.25781 10.5078 9 10.9297 9H12.875C13.4844 9 14 9.51562 14 10.125V12.375C14 13.0078 13.4844 13.5 12.875 13.5H3.125C2.49219 13.5 2 13.0078 2 12.375V10.125C2 9.51562 2.49219 9 3.125 9H5.04688C5.46875 9 5.86719 9.25781 6.05469 9.63281Z" fill="#00C244"/>
              </svg>
            </span>
            <span
              *ngIf="
                (element.caseCompletionStatus?.toLowerCase() ==
                'determination approved'
                || element.workflowStatus?.toLowerCase() ==
                'determination approved')
                && (element.caseCompletionStatus?.toLowerCase() != 'terminated')
              "
            >
              <!-- green tick icon -->
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.0947 4.49902C13.3057 4.7334 13.3057 5.08496 13.0947 5.2959L6.90723 11.4834C6.67285 11.7178 6.32129 11.7178 6.11035 11.4834L2.92285 8.2959C2.68848 8.08496 2.68848 7.7334 2.92285 7.52246C3.13379 7.28809 3.48535 7.28809 3.69629 7.52246L6.48535 10.3115L12.2979 4.49902C12.5088 4.28809 12.8604 4.28809 13.0713 4.49902H13.0947Z" fill="#00C244"/>
              </svg>
            </span>
            <span
              *ngIf="
                (element.caseCompletionStatus?.toLowerCase() ==
                'determination in progress'
                || element.workflowStatus?.toLowerCase() ==
                'determination in progress')
                && (element.caseCompletionStatus?.toLowerCase() != 'terminated')
              "
            >
              <!-- blue loading icon -->
              <svg
                width="16"
                height="16"
                viewBox="0 1 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.5625 3.0625V4.9375C8.5625 5.26562 8.30469 5.5 8 5.5C7.67188 5.5 7.4375 5.26562 7.4375 4.9375V3.0625C7.4375 2.75781 7.67188 2.5 8 2.5C8.30469 2.5 8.5625 2.75781 8.5625 3.0625ZM8.5625 12.0625V13.9375C8.5625 14.2656 8.30469 14.5 8 14.5C7.67188 14.5 7.4375 14.2656 7.4375 13.9375V12.0625C7.4375 11.7578 7.67188 11.5 8 11.5C8.30469 11.5 8.5625 11.7578 8.5625 12.0625ZM2 8.5C2 8.19531 2.23438 7.9375 2.5625 7.9375H4.4375C4.74219 7.9375 5 8.19531 5 8.5C5 8.82812 4.74219 9.0625 4.4375 9.0625H2.5625C2.23438 9.0625 2 8.82812 2 8.5ZM11.5625 7.9375H13.4375C13.7422 7.9375 14 8.19531 14 8.5C14 8.82812 13.7422 9.0625 13.4375 9.0625H11.5625C11.2344 9.0625 11 8.82812 11 8.5C11 8.19531 11.2344 7.9375 11.5625 7.9375ZM12.2422 4.25781C12.4531 4.49219 12.4531 4.84375 12.2422 5.05469L10.9062 6.39062C10.6953 6.60156 10.3203 6.60156 10.1094 6.39062C9.89844 6.17969 9.89844 5.80469 10.1094 5.59375L11.4453 4.25781C11.6562 4.04688 12.0078 4.04688 12.2422 4.25781ZM5.86719 11.4297L4.53125 12.7422C4.32031 12.9766 3.96875 12.9766 3.75781 12.7422C3.52344 12.5312 3.52344 12.1797 3.75781 11.9688L5.07031 10.6328C5.28125 10.4219 5.65625 10.4219 5.86719 10.6328C6.07812 10.8438 6.07812 11.1953 5.86719 11.4297ZM3.75781 4.25781C3.96875 4.04688 4.32031 4.04688 4.53125 4.25781L5.86719 5.59375C6.07812 5.80469 6.07812 6.17969 5.86719 6.39062C5.65625 6.60156 5.30469 6.60156 5.07031 6.39062L3.75781 5.05469C3.52344 4.84375 3.52344 4.49219 3.75781 4.25781ZM10.9062 10.6328L12.2422 11.9688C12.4531 12.1797 12.4531 12.5312 12.2422 12.7422C12.0078 12.9766 11.6562 12.9766 11.4453 12.7422L10.1094 11.4297C9.89844 11.2188 9.89844 10.8438 10.1094 10.6328C10.3203 10.4219 10.6953 10.4219 10.9062 10.6328Z"
                  fill="#43C5E1"
                />
              </svg>
            </span>
            <span
              *ngIf="
                (element.caseCompletionStatus?.toLowerCase() ==
                  'assessment appointment scheduled' ||
                element.caseCompletionStatus?.toLowerCase() ==
                  'non response to call'
                || element.workflowStatus?.toLowerCase() ==
                  'assessment appointment scheduled' ||
                element.workflowStatus?.toLowerCase() ==
                  'non response to call')
                && (element.caseCompletionStatus?.toLowerCase() != 'terminated')
              "
            >
              <!-- orange calendar icon -->
              <svg
                width="16"
                height="16"
                viewBox="0 1 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 2C6.30469 2 6.5625 2.25781 6.5625 2.5625V3.5H9.9375V2.5625C9.9375 2.25781 10.1719 2 10.5 2C10.8047 2 11.0625 2.25781 11.0625 2.5625V3.5H12C12.8203 3.5 13.5 4.17969 13.5 5V5.375V6.5V12.5C13.5 13.3438 12.8203 14 12 14H4.5C3.65625 14 3 13.3438 3 12.5V6.5V5.375V5C3 4.17969 3.65625 3.5 4.5 3.5H5.4375V2.5625C5.4375 2.25781 5.67188 2 6 2ZM12.375 6.5H4.125V12.5C4.125 12.7109 4.28906 12.875 4.5 12.875H12C12.1875 12.875 12.375 12.7109 12.375 12.5V6.5Z"
                  fill="#F9A644"
                />
              </svg>
            </span>
            <span
              *ngIf="
                (element.caseCompletionStatus?.toLowerCase() ==
                'appointment rescheduled' ||
                element.workflowStatus?.toLowerCase() ==
                'appointment rescheduled')
                && (element.caseCompletionStatus?.toLowerCase() != 'terminated')
              "
            >
              <!-- orange calendar icon -->
              <svg
                width="16"
                height="16"
                viewBox="0 1 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 2C6.30469 2 6.5625 2.25781 6.5625 2.5625V3.5H9.9375V2.5625C9.9375 2.25781 10.1719 2 10.5 2C10.8047 2 11.0625 2.25781 11.0625 2.5625V3.5H12C12.8203 3.5 13.5 4.17969 13.5 5V5.375V6.5V12.5C13.5 13.3438 12.8203 14 12 14H4.5C3.65625 14 3 13.3438 3 12.5V6.5V5.375V5C3 4.17969 3.65625 3.5 4.5 3.5H5.4375V2.5625C5.4375 2.25781 5.67188 2 6 2ZM12.375 6.5H4.125V12.5C4.125 12.7109 4.28906 12.875 4.5 12.875H12C12.1875 12.875 12.375 12.7109 12.375 12.5V6.5Z"
                  fill="#F9A644"
                />
              </svg>
            </span>
            <span
              *ngIf="
                (element.caseCompletionStatus?.toLowerCase() ==
                'missed the appointment' ||
                element.workflowStatus?.toLowerCase() ==
                'missed the appointment')
                && (element.caseCompletionStatus?.toLowerCase() != 'terminated')
              "
            >
              <!-- orange calendar icon -->
              <svg
                width="16"
                height="16"
                viewBox="0 1 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 2C6.30469 2 6.5625 2.25781 6.5625 2.5625V3.5H9.9375V2.5625C9.9375 2.25781 10.1719 2 10.5 2C10.8047 2 11.0625 2.25781 11.0625 2.5625V3.5H12C12.8203 3.5 13.5 4.17969 13.5 5V5.375V6.5V12.5C13.5 13.3438 12.8203 14 12 14H4.5C3.65625 14 3 13.3438 3 12.5V6.5V5.375V5C3 4.17969 3.65625 3.5 4.5 3.5H5.4375V2.5625C5.4375 2.25781 5.67188 2 6 2ZM12.375 6.5H4.125V12.5C4.125 12.7109 4.28906 12.875 4.5 12.875H12C12.1875 12.875 12.375 12.7109 12.375 12.5V6.5Z"
                  fill="#F9A644"
                />
              </svg>
            </span>
            <span
              *ngIf="
                (element.caseCompletionStatus?.toLowerCase() == 'assessment done'
                || element.workflowStatus?.toLowerCase() == 'assessment done')
                && (element.caseCompletionStatus?.toLowerCase() != 'terminated')
              "
            >
              <!-- orange tick icon -->
              <svg
                width="16"
                height="16"
                viewBox="0 1 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.0947 4.49902C13.3057 4.7334 13.3057 5.08496 13.0947 5.2959L6.90723 11.4834C6.67285 11.7178 6.32129 11.7178 6.11035 11.4834L2.92285 8.2959C2.68848 8.08496 2.68848 7.7334 2.92285 7.52246C3.13379 7.28809 3.48535 7.28809 3.69629 7.52246L6.48535 10.3115L12.2979 4.49902C12.5088 4.28809 12.8604 4.28809 13.0713 4.49902H13.0947Z"
                  fill="#F9A644"
                />
              </svg>
            </span>
            <span
              *ngIf="
                (element.caseCompletionStatus?.toLowerCase() ==
                  'assessment in progress' ||
                element.caseCompletionStatus?.toLowerCase() ==
                  'appointment in progress' ||
                element.workflowStatus?.toLowerCase() ==
                  'assessment in progress' ||
                element.workflowStatus?.toLowerCase() ==
                  'appointment in progress')
                  && (element.caseCompletionStatus?.toLowerCase() != 'terminated')
              "
            >
              <!-- orange loading icon -->
              <svg
                width="16"
                height="16"
                viewBox="0 1 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.5625 3.0625V4.9375C8.5625 5.26562 8.30469 5.5 8 5.5C7.67188 5.5 7.4375 5.26562 7.4375 4.9375V3.0625C7.4375 2.75781 7.67188 2.5 8 2.5C8.30469 2.5 8.5625 2.75781 8.5625 3.0625ZM8.5625 12.0625V13.9375C8.5625 14.2656 8.30469 14.5 8 14.5C7.67188 14.5 7.4375 14.2656 7.4375 13.9375V12.0625C7.4375 11.7578 7.67188 11.5 8 11.5C8.30469 11.5 8.5625 11.7578 8.5625 12.0625ZM2 8.5C2 8.19531 2.23438 7.9375 2.5625 7.9375H4.4375C4.74219 7.9375 5 8.19531 5 8.5C5 8.82812 4.74219 9.0625 4.4375 9.0625H2.5625C2.23438 9.0625 2 8.82812 2 8.5ZM11.5625 7.9375H13.4375C13.7422 7.9375 14 8.19531 14 8.5C14 8.82812 13.7422 9.0625 13.4375 9.0625H11.5625C11.2344 9.0625 11 8.82812 11 8.5C11 8.19531 11.2344 7.9375 11.5625 7.9375ZM12.2422 4.25781C12.4531 4.49219 12.4531 4.84375 12.2422 5.05469L10.9062 6.39062C10.6953 6.60156 10.3203 6.60156 10.1094 6.39062C9.89844 6.17969 9.89844 5.80469 10.1094 5.59375L11.4453 4.25781C11.6562 4.04688 12.0078 4.04688 12.2422 4.25781ZM5.86719 11.4297L4.53125 12.7422C4.32031 12.9766 3.96875 12.9766 3.75781 12.7422C3.52344 12.5312 3.52344 12.1797 3.75781 11.9688L5.07031 10.6328C5.28125 10.4219 5.65625 10.4219 5.86719 10.6328C6.07812 10.8438 6.07812 11.1953 5.86719 11.4297ZM3.75781 4.25781C3.96875 4.04688 4.32031 4.04688 4.53125 4.25781L5.86719 5.59375C6.07812 5.80469 6.07812 6.17969 5.86719 6.39062C5.65625 6.60156 5.30469 6.60156 5.07031 6.39062L3.75781 5.05469C3.52344 4.84375 3.52344 4.49219 3.75781 4.25781ZM10.9062 10.6328L12.2422 11.9688C12.4531 12.1797 12.4531 12.5312 12.2422 12.7422C12.0078 12.9766 11.6562 12.9766 11.4453 12.7422L10.1094 11.4297C9.89844 11.2188 9.89844 10.8438 10.1094 10.6328C10.3203 10.4219 10.6953 10.4219 10.9062 10.6328Z"
                  fill="#F9A644"
                />
              </svg>
            </span>
            <ng-container
              *ngIf="
                (element.caseCompletionStatus?.toLowerCase() ==
                  'review requested' ||
                element.caseCompletionStatus?.toLowerCase() ==
                  'info/ docs requested' ||
                element.caseCompletionStatus?.toLowerCase() ==
                  'review in progress'
                || element.workflowStatus?.toLowerCase() ==
                  'review requested' ||
                element.workflowStatus?.toLowerCase() ==
                  'info/ docs requested' ||
                element.workflowStatus?.toLowerCase() ==
                  'review in progress')
                  && (element.caseCompletionStatus?.toLowerCase() != 'terminated')
              "
            >
              <!-- purple loading icon -->
              <svg
                width="16"
                height="16"
                viewBox="0 1 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.5625 3.0625V4.9375C8.5625 5.26562 8.30469 5.5 8 5.5C7.67188 5.5 7.4375 5.26562 7.4375 4.9375V3.0625C7.4375 2.75781 7.67188 2.5 8 2.5C8.30469 2.5 8.5625 2.75781 8.5625 3.0625ZM8.5625 12.0625V13.9375C8.5625 14.2656 8.30469 14.5 8 14.5C7.67188 14.5 7.4375 14.2656 7.4375 13.9375V12.0625C7.4375 11.7578 7.67188 11.5 8 11.5C8.30469 11.5 8.5625 11.7578 8.5625 12.0625ZM2 8.5C2 8.19531 2.23438 7.9375 2.5625 7.9375H4.4375C4.74219 7.9375 5 8.19531 5 8.5C5 8.82812 4.74219 9.0625 4.4375 9.0625H2.5625C2.23438 9.0625 2 8.82812 2 8.5ZM11.5625 7.9375H13.4375C13.7422 7.9375 14 8.19531 14 8.5C14 8.82812 13.7422 9.0625 13.4375 9.0625H11.5625C11.2344 9.0625 11 8.82812 11 8.5C11 8.19531 11.2344 7.9375 11.5625 7.9375ZM12.2422 4.25781C12.4531 4.49219 12.4531 4.84375 12.2422 5.05469L10.9062 6.39062C10.6953 6.60156 10.3203 6.60156 10.1094 6.39062C9.89844 6.17969 9.89844 5.80469 10.1094 5.59375L11.4453 4.25781C11.6562 4.04688 12.0078 4.04688 12.2422 4.25781ZM5.86719 11.4297L4.53125 12.7422C4.32031 12.9766 3.96875 12.9766 3.75781 12.7422C3.52344 12.5312 3.52344 12.1797 3.75781 11.9688L5.07031 10.6328C5.28125 10.4219 5.65625 10.4219 5.86719 10.6328C6.07812 10.8438 6.07812 11.1953 5.86719 11.4297ZM3.75781 4.25781C3.96875 4.04688 4.32031 4.04688 4.53125 4.25781L5.86719 5.59375C6.07812 5.80469 6.07812 6.17969 5.86719 6.39062C5.65625 6.60156 5.30469 6.60156 5.07031 6.39062L3.75781 5.05469C3.52344 4.84375 3.52344 4.49219 3.75781 4.25781ZM10.9062 10.6328L12.2422 11.9688C12.4531 12.1797 12.4531 12.5312 12.2422 12.7422C12.0078 12.9766 11.6562 12.9766 11.4453 12.7422L10.1094 11.4297C9.89844 11.2188 9.89844 10.8438 10.1094 10.6328C10.3203 10.4219 10.6953 10.4219 10.9062 10.6328Z"
                  fill="#8180DC"
                />
              </svg>
            </ng-container>
            <span
              *ngIf="
                (element.caseCompletionStatus?.toLowerCase() ==
                'assessment in scheduling'
                || element.workflowStatus?.toLowerCase() ==
                'assessment in scheduling')
                && (element.caseCompletionStatus?.toLowerCase() != 'terminated')
              "
            >
              <!-- orange calendar icon -->
              <svg
                width="16"
                height="16"
                viewBox="0 1 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 2C6.30469 2 6.5625 2.25781 6.5625 2.5625V3.5H9.9375V2.5625C9.9375 2.25781 10.1719 2 10.5 2C10.8047 2 11.0625 2.25781 11.0625 2.5625V3.5H12C12.8203 3.5 13.5 4.17969 13.5 5V5.375V6.5V12.5C13.5 13.3438 12.8203 14 12 14H4.5C3.65625 14 3 13.3438 3 12.5V6.5V5.375V5C3 4.17969 3.65625 3.5 4.5 3.5H5.4375V2.5625C5.4375 2.25781 5.67188 2 6 2ZM12.375 6.5H4.125V12.5C4.125 12.7109 4.28906 12.875 4.5 12.875H12C12.1875 12.875 12.375 12.7109 12.375 12.5V6.5Z"
                  fill="#F9A644"
                />
              </svg>
            </span>
            <span
              *ngIf="
                (element.caseCompletionStatus?.toLowerCase() == 'review done'
                || element.workflowStatus?.toLowerCase() == 'review done')
                && (element.caseCompletionStatus?.toLowerCase() != 'terminated')
              "
            >
              <!-- purple tick icon -->
              <svg
                width="16"
                height="16"
                viewBox="0 1 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.0947 4.49902C13.3057 4.7334 13.3057 5.08496 13.0947 5.2959L6.90723 11.4834C6.67285 11.7178 6.32129 11.7178 6.11035 11.4834L2.92285 8.2959C2.68848 8.08496 2.68848 7.7334 2.92285 7.52246C3.13379 7.28809 3.48535 7.28809 3.69629 7.52246L6.48535 10.3115L12.2979 4.49902C12.5088 4.28809 12.8604 4.28809 13.0713 4.49902H13.0947Z"
                  fill="#8180DC"
                />
              </svg>
            </span>
            {{ element.caseCompletionStatus ? element.caseCompletionStatus : 
            element.workflowStatus ? element.workflowStatus : 'Draft' }}</span
          >
        </ng-container>
      </td>
    </ng-container>
      <tr mat-header-row *matHeaderRowDef="columnKeyValues"></tr>
    <tr mat-row *matRowDef="let row; columns: columnKeyValues"></tr>
  </table>
  <!-- Pagination Heading for Accessibility -->
  <h2 id="paginationHeading" class="sr-only">Table Pagination</h2>
  <!-- Server side pagination : Does api call on every pagination event change -->
  <mat-paginator
    *ngIf="serverSidePagination"
    [length]="totalElements"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="[10, 25, 50, 100]"
    aria-label="Select page"
    aria-describedby="paginationHeading"
    (page)="getPaginatorData($event)"
    showFirstLastButtons
  >
  </mat-paginator>
  <!-- Client side pagination : Default Material pagination -->
  <!-- <mat-paginator *ngIf="!serverSidePagination"
        [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons>
    </mat-paginator> -->
